import cx from 'classnames';
import { t } from 'i18next';
import { RecruitmentActivityType } from '../../../../../../shared/types/recruitmentTypes';
import { RecruitmentEntityType } from '../../../../../../shared/types/recruitmentTypes';
import { SimpleSelect } from '../../../../../../shared/frontend/components/SimpleSelect';
import { TSimpleSelectOnChangeParams } from '../../../../../../shared/frontend/components/SimpleSelect';
import { getRequiredTransferRequirements } from '../utils';

function glyphForBoolean(enabled: boolean) {
  return (
    <i
      className={cx(
        'fa',
        enabled ? 'fa-circle-check rio-rec-tag--special-enabled' : 'fa-hexagon-xmark rio-rec-tag--special-disabled'
      )}
    />
  );
}

type TGetTransferTagsProps = {
  entity_type: string;
  activity_type: string;
  is_cross_realm_allowed: boolean | null | undefined;
  is_realm_transfer_allowed: boolean | null | undefined;
  is_faction_transfer_allowed: boolean | null | undefined;
};

export function getTransferTags(params: TGetTransferTagsProps) {
  const tags = [];

  const askAbout = getRequiredTransferRequirements(
    params.entity_type as RecruitmentEntityType,
    params.activity_type as RecruitmentActivityType
  );

  if (askAbout.crossRealm && params.is_cross_realm_allowed) {
    tags.push({
      id: 1,
      description: t('recruitment:transfer-requirements.cross-realm-faction-ok'),
      name: <>{t('recruitment:transfer-requirements.cross-realm-faction')} {glyphForBoolean(params.is_cross_realm_allowed)}</>
    });
  }

  if (askAbout.realmTransfer && params.is_realm_transfer_allowed) {
    tags.push({
      id: 2,
      description: t('recruitment:transfer-requirements.realm-transfer-ok'),
      name: <>{t('recruitment:transfer-requirements.realm-transfer')} {glyphForBoolean(params.is_realm_transfer_allowed)}</>
    });
  }

  if (askAbout.factionTransfer && params.is_faction_transfer_allowed) {
    tags.push({
      id: 3,
      description: t('recruitment:transfer-requirements.faction-transfer-ok'),
      name: <>{t('recruitment:transfer-requirements.faction-transfer')} {glyphForBoolean(params.is_faction_transfer_allowed)}</>
    });
  }

  return tags;
}

export const TransferQuestions = (props: any) => {
  const { profile, updateProfileField } = props;

  const askAbout = getRequiredTransferRequirements(profile.entity_type, profile.activity_type);
  if (!askAbout.any) {
    return null;
  }

  let crossRealmLabel = 'Are you open to cross-realm/cross-faction players?';
  if (profile.entity_type === RecruitmentEntityType.Character) {
    crossRealmLabel = 'Are you open to playing with cross-realm/cross-faction groups?';
  } else if (profile.activity_type === RecruitmentActivityType.GuildRaids) {
    crossRealmLabel = 'Are you open to cross-realm/cross-faction raiding?';
  }

  return (
    <div className="slotEntryContainer slds-m-bottom--medium">
      {askAbout.crossRealm && (
        <fieldset className="slds-form--compound recruitment--req-fields">
          <div className="slds-m-bottom--x-small">{crossRealmLabel} *</div>

          <SimpleSelect
            onChange={(target: TSimpleSelectOnChangeParams) =>
              updateProfileField('is_cross_realm_allowed', target.value === '' ? null : target.value === 'true')
            }
            value={
              typeof profile.is_cross_realm_allowed === 'boolean'
                ? profile.is_cross_realm_allowed.toString()
                : undefined
            }
            options={[
              {
                label: '',
                value: ''
              },
              {
                label: 'Yes',
                value: 'true'
              },
              {
                label: 'No',
                value: 'false'
              }
            ]}
          />
        </fieldset>
      )}
      {askAbout.realmTransfer && (
        <fieldset className="slds-form--compound recruitment--req-fields">
          <div className="slds-m-bottom--x-small ">Are you willing to transfer realms? *</div>

          <SimpleSelect
            onChange={(target: TSimpleSelectOnChangeParams) =>
              updateProfileField('is_realm_transfer_allowed', target.value === '' ? null : target.value === 'true')
            }
            value={
              typeof profile.is_realm_transfer_allowed === 'boolean'
                ? profile.is_realm_transfer_allowed.toString()
                : undefined
            }
            options={[
              {
                label: '',
                value: ''
              },
              {
                label: 'Yes',
                value: 'true'
              },
              {
                label: 'No',
                value: 'false'
              }
            ]}
          />
        </fieldset>
      )}

      {askAbout.factionTransfer && (
        <fieldset className="slds-form--compound recruitment--req-fields">
          <div className="slds-m-bottom--x-small">Are you willing to change factions? *</div>

          <SimpleSelect
            onChange={(target: TSimpleSelectOnChangeParams) =>
              updateProfileField('is_faction_transfer_allowed', target.value === '' ? null : target.value === 'true')
            }
            value={
              typeof profile.is_faction_transfer_allowed === 'boolean'
                ? profile.is_faction_transfer_allowed.toString()
                : undefined
            }
            options={[
              {
                label: '',
                value: ''
              },
              {
                label: 'Yes',
                value: 'true'
              },
              {
                label: 'No',
                value: 'false'
              }
            ]}
          />
        </fieldset>
      )}
    </div>
  );
};
